enum ReportSorting {
  Default = 0,
  SamplingPointReferenceAndMaterial = 1
}

export default ReportSorting;
